var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.settlementLink,"target":_vm.openInNewTab ? '_blank' : '_self',"title":_vm.trans('settlement.showObjectsInGroup', {group: _vm.settlement.month})}},[_vm._v(" "+_vm._s(_vm.settlementName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }